<script lang="ts">
  import type { Snippet } from 'svelte'
  import { getCsrfToken, getInertiaCsrfToken } from 'shared/javascripts/util/csrf'

  let { action, children }: { action: string; children: Snippet } = $props()
</script>

<!-- Logout is a DELETE, which only a submitted form can send in both frontends. -->
<form method="post" {action}>
  <input type="hidden" name="_method" value="delete" />
  <input
    type="hidden"
    name="authenticity_token"
    value={getInertiaCsrfToken() ?? getCsrfToken() ?? ''}
  />
  {@render children()}
</form>

<style>
  form {
    display: flex;
    width: 100%;
  }
</style>
